<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Branch" :required="true">
              <input
                @blur="$v.branch.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.branch.name.$error }"
                v-model="branch.name"
              />
              <div class="invalid-feedback" v-if="!$v.branch.name.required">
                Please enter branch
              </div>
            </form-group>

            
             <form-group label="Code" :required="true">
             <input
                @blur="$v.branch.code.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.branch.code.$error }"
                v-model="branch.code"
                v-uppercase
              />
              <div
                class="invalid-feedback"
                v-if="!$v.branch.code.required"
              >
                Please enter code
              </div>
            </form-group>

            <form-group label="Image">
              <image-upload @files-uploaded=" branch.image_id = $event;
              imageUploading = false; " @files-uploaded-started="imageUploading
              = true" :multiple="false" :imageCrop=true :imageCropRatio=1/1
              :validationState="imageVstate" acceptedTypes="image/*" />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import branchRepo from "@/api/repos/branchRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    branch: {
      name: {
        required,
      },
       code:{
        required
      }
    },
  },

  mounted() {},

  data() {
    return {
      branch: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await branchRepo.create(this.branch);
          this.$emit("branchCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

